import React, { forwardRef, useRef, useImperativeHandle } from 'react'
import { object } from 'prop-types'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { useAuthenticationState } from '../../../../../contexts/AuthenticationContext'
import { userMenuMessages } from '../../../../../translations'
import { baseTiltifyUrl, getSubdomainUrl } from '../../../../../utils'
import { Button } from '../../../../Button'

const StyledButton = styled(Button)`
  display: flex;
  font-size: 0.8125rem !important;
  font-weight: normal !important;
  padding: 0.625rem 1.0625rem;
  border: none;
  color: ${({ theme }) => theme.textColor} !important;
`

export const FrontendUserEditCampaign = forwardRef(({ campaign }, ref) => {
  const { user } = useAuthenticationState()
  const { formatMessage } = useIntl()
  const localRef = useRef()
  useImperativeHandle(ref, () => localRef.current)

  const baseURL = getSubdomainUrl(baseTiltifyUrl(), 'app')
  const redirectUrl =
    campaign?.team && campaign?.team?.slug
      ? `${baseURL}/users/${user.slug}/teams/${campaign.team.slug}/campaigns/${campaign.slug}/overview`
      : `${baseURL}/users/${user.slug}/campaigns/${campaign.slug}/detail`

  return (
    <StyledButton forwardedAs='a' href={redirectUrl} ref={localRef}>
      {formatMessage(userMenuMessages.editCampaign)}
    </StyledButton>
  )
})

FrontendUserEditCampaign.propTypes = {
  campaign: object,
}
